<div
  (touchmove)="stopScroll($event)"
  [ngStyle]="{ height: isMobile && !isSafari ? windowHeight : '100vh' }"
  class="card-page">
  <div class="body-gradient">
    <div class="create-container container full-height">
      <div class="wrapper-section full-height">
        <div #pitchCardWrapper class="pitchcard-view-section">
          <div style="width: 100%">
            @if (businessDetails) {
              <app-pitch-card
                #previewCard
                [mutedVideo]="true"
                [isSearchCard]="true"
                [showAutoplayOverlay]="true"
                (titleClick)="handlePitchCardTitleClick($event)"
                (isVideoLoaded)="
                  isPlayThumbnailVideo ? playInlineVideo() : null"
                [biggerText]="true"
                [uniqueId]="uniqueId"
                [inputBusinessDetails]="businessDetails"
                [scale]="scale"></app-pitch-card>
            }
            @else
            {
              <div class="coming-soon">PitchCard not available</div>
            }
          </div>
        </div>
      </div>
    </div>
    <a
      (click)="goToPage()"
      class="card-page-footer mobile justify-content-center">
      <span>Create your own PitchCard</span>
      <img
        src="./assets/images/logo/pitch59-logo-white.svg"
        width="80"
        height="27"
        alt="" />
    </a>
  </div>
</div>

<app-pitchcard-modals-wrapper
  [uniqueId]="uniqueId"></app-pitchcard-modals-wrapper>

<p-confirmDialog></p-confirmDialog>
